import type { ReactNode } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { ChromeDialog } from './chrome_dialog.tsx';

// A question with two answers, over the page (Chakra's Dialog). Not `window.confirm`: the Android
// WebView shows nothing for it unless the shell implements it.

export interface ConfirmDialogProps {
    message: string;
    confirm: string;
    cancel: string;
    onConfirm: () => void;
    onCancel: () => void;
    /** The title above the question. */
    title?: string;
}

export function ConfirmDialog({ message, confirm, cancel, onConfirm, onCancel, title = 'Are you sure?' }: ConfirmDialogProps) : ReactNode {
    return (
        <ChromeDialog
            title={title}
            onClose={onCancel}
            isQuestion
            size="sm"
            footer={
                <>
                    <Button variant="outline" onClick={onCancel}>
                        {cancel}
                    </Button>
                    <Button colorPalette="red" onClick={onConfirm}>
                        {confirm}
                    </Button>
                </>
            }
        >
            <Text>{message}</Text>
        </ChromeDialog>
    );
}
